import React from 'react'
import ReactDOM from 'react-dom'

import { BrowserRouter } from 'react-router-dom'
import Background from './components/Background'
import LoginApp from './components/Login/App'
import BrowserCheck from './components/BrowserCheck'

import './index.css'
import './components/Layout.css'

console.info(window.navigator.userAgent) // diagnostic info

document.body.style.backgroundImage = `url(${Background()})`

ReactDOM.render((
  <div className='webmango'>
    <BrowserCheck>
      <BrowserRouter basename='/login'>
        <LoginApp />
      </BrowserRouter>
    </BrowserCheck>
  </div>
), document.querySelector('#root'))



// WEBPACK FOOTER //
// ./src/login.js